<template> 
     <BaseModal
        :id="'static-survey'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_simulated()">

                <div class="row m-0 formdynamic justify-content-md-between" v-if="!manual_table.length && !random_table.length">
                    <div v-for="(key, index) in boolean_option" :key="index" :class="key.css_class" class="p-0">
                        <div class="formdynamic__item__field">
                            <div class="d-inline-block" >
                                <div v-for="(val, i) in key.childs" :key="i" :class="'custom-radio custom-control-inline'" style="margin-left:5px;">
                                    <input 
                                        :class="'custom-control-input'" 
                                        :type="'radio'" 
                                        :id="val.ref" 
                                        v-model="form_data[key.model_name]" 
                                        :value="val.value"
                                    />
                                    <label 
                                        :for="val.ref" 
                                        :class="'form-check-label custom-control-label'" 
                                        v-html="val.name"
                                    />
                                </div> 
                            </div>

                        </div>
                    </div>
                </div>

                <FormDynamic
                    :form_format="form_data.random ? form_format_lite : form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <div class="row m-0" v-if="form_data.random && !random_table.length">
                    <button class="button--2 mt-3 ml-auto" v-html="'Search'" type="button" @click="random_recipients()"/>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                v-if="form_data.random"
                                :headers="table_headers"
                                :items="random_associates"
                                :search="search"
                                :selectable_columns="false"
                                :checkable="true"
                                :size="23"
                            />

                            <DinamicTable
                                v-else
                                :headers="table_headers"
                                :items="manual_associates"
                                :search="search"
                                :selectable_columns="false"
                                :checkable="true"
                                :size="23"
                            />
                        </v-card>
                    </div>
                </div>
                <CentralButtons :ext="'static-survey'"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import DinamicTable     from '@/components/DinamicTable'

export default {

    name:   'SendSurveyFormModal',

    props: [
        'title',
        'parent_id',
        'rest_api',
        'notifications',
        'notyf',
        'array_options',
        'breadcrumb',
        'parent'
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
        DinamicTable
    },

    data(){
        return{
            form_data: FormResources.send_survey_form_data,
            form_backup: {...FormResources.send_survey_form_data},

            form_format: FormResources.send_survey_form_format,
            form_format_lite: FormResources.send_survey_form_format_lite,

            search: '',
            manual_associates: [],
            random_associates: [],
            manual_table: [],
            random_table: [],

            boolean_option: FormResources.boolean_option,

            table_headers: [
                { 
                  text:     'Last name',
                  align:    'start', 
                  value:    'last_name'
                },
                { 
                  text:     'First name',
                  value:    'first_name'
                },
                { 
                  text:     'Email',
                  value:    'email'
                },
                { 
                  text:     'From',
                  value:    'module'
                },
            ],
        }
    },

    watch: {

        async 'form_data.cost_center_id'(val)
        {
            if(val)
            {
                let http_request = {
                    department_request: true,
                    id: val,
                }

                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

                if(response.status)
                {
                    if(response.data.departments.length)
                    {
                        this.array_options.cost_center_department_id = response.data.departments
                        this.notyf.success('Departments available')
                    }
                    else
                    {
                        this.array_options.cost_center_department_id = []
                        this.notyf.error('Departments no data available')
                    }
                    this.form_data.cost_center_department_id = ''
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

        async 'form_data.cost_center_department_id'(val)
        {
            if(val)
            {
                let http_request = {
                    associate_request: true,
                    id: val,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

                if(response.status)
                {
                    if(response.data.associates.length)
                    {
                        this.manual_associates = response.data.associates
                        this.notyf.success('Associates available')
                    }
                    else
                    {
                        this.manual_associates = []
                        this.notyf.error('Associates no data available')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

        'form_data.number'(val)
        {
            if(val < 1)
            {
                this.form_data.number = 1
            }
        },

    },

    methods:{

        async random_recipients()
        {
            if(this.form_data.number < 1)
            {
                this.notyf.error('Invalid number')
                return false
            }

            let http_request = {
                random_request: true,
                count: parseInt(this.form_data.number),
            }

            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

            if(response.status)
            {
                if(response.data.associates.length)
                {
                    this.random_associates = response.data.associates
                    this.notyf.success('Associates available')
                }
                else
                {
                    this.random_associates = []
                    this.notyf.error('Associates no data available')
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        async form_submit_simulated()
        {
            let current_url = window.location.href
            this.form_data.survey_url = new URL('/qc-survey-test-completion/', current_url)
            let select_ids = []
            
            if(this.form_data.random)
            {
                select_ids = this.random_associates.filter(item => item.checked)
                delete this.form_data.cost_center_department_id 
                delete this.form_data.cost_center_id
            }
            else
            {
                select_ids = this.manual_associates.filter(item => item.checked)
            }
                
            if(!select_ids)
            {
                this.notyf.error('No associates selected')
                return false
            }

            this.form_data.associate_id = select_ids
            this.form_data.survey_id = this.parent_id

            const response = await this.form_submit('static-survey', this.form_data)

            if(response)
            {
                this.form_data = {...this.form_backup}
                this.random_table = []
                this.random_associates = []
                this.manual_table = []
                this.manual_associates = []
                return true
            }
        },

        initiate(subject, message)
        {
            this.form_backup.subject = subject
            this.form_backup.email_body = message
            this.form_data.subject = subject
            this.form_data.email_body = message
        }
        
    },

    mounted(){

    }
    
}
</script>